import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: [
    'M18.5 1h-17C.675 1 0 1.675 0 2.5v14c0 .825.675 1.5 1.5 1.5H8v1H5.5c-.276 0-.5.224-.5.5s.224.5.5.5h9c.276 0 .5-.224.5-.5s-.224-.5-.5-.5H12v-1h6.5c.825 0 1.5-.675 1.5-1.5v-14c0-.825-.675-1.5-1.5-1.5zM9 19v-1h2v1H9zm10-2.5c0 .271-.229.5-.5.5h-17c-.271 0-.5-.229-.5-.5V15h18v1.5zm0-2.5H1V2.5c0-.271.229-.5.5-.5h17c.271 0 .5.229.5.5V14z',
  ],
  height: 20,
  width: 20,
});
